









import { Vue, Component, Prop } from 'vue-property-decorator';
import Checkbox from './Checkbox.vue';
import { LikertScaleKeys, LikertScaleLabels } from '@/models/likert-scale';

@Component({
  components: {
    Checkbox
  }
})
export default class LikertScale extends Vue {
  @Prop(String) value!: string;
  @Prop(Boolean) disabled!: boolean;
  @Prop(Boolean) hasError!: boolean;

  items = [
    { value: LikertScaleKeys.VERY_HIGH, label: LikertScaleLabels.VERY_HIGH },
    { value: LikertScaleKeys.HIGH, label: LikertScaleLabels.HIGH },
    { value: LikertScaleKeys.LOW, label: LikertScaleLabels.LOW },
    { value: LikertScaleKeys.VERY_LOW, label: LikertScaleLabels.VERY_LOW },
    { value: LikertScaleKeys.UNKNOWN, label: LikertScaleLabels.UNKNOWN }
  ];

  LikertScaleLabels = LikertScaleLabels;

  select(key: string) {
    if (!this.disabled) {
      this.$emit('change', key);
    }
  }
}
